import { buildRoute, noEnvRoutes } from "@/assets/routes/routes";
import api from "../api";
import { isAxiosError } from "axios";
import type { IQuestion } from "@/types/types";
import { v4 as uuidv4 } from "uuid";

export const getQuestions = async (inspection_type: number) => {
  try {
    const url = buildRoute(noEnvRoutes.getQuestionsByInspection, {
      inspection_type: inspection_type,
    });
    const { data } = await api.get(url);

    return data.questions;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getAllQuestions = async ({ page }: { page?: number }) => {
  try {
    let queryParams = "lastVersion=true";

    if (typeof page === "number" && page >= 0) {
      queryParams += `&page=${page}`;
    }
    if (queryParams) queryParams = `?${queryParams}`;

    const { data } = await api.get(
      `${noEnvRoutes.inspectionsType}${queryParams}`,
    );
    return { ...data };
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getQuestionById = async (id: string) => {
  try {
    const url = buildRoute(noEnvRoutes.inspectionsTypeId, { id });
    const { data } = await api.get(url);
    const questions = data.questions.map((it: IQuestion) => ({
      ...it,
      questionId: uuidv4(),
    }));
    return { ...data, questions };
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const updateQuestions = async (body: {
  type: string;
  questions: IQuestion[];
}) => {
  try {
    await api.post(noEnvRoutes.inspectionsType, body);

    return;
  } catch (error) {
    if (isAxiosError(error) && error.message) {
      console.error(error);
      throw new Error(error.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};
